import { invoke } from '@shared/easyfy.decorators';
import '../banner/bannercomponent';

@invoke
export default class MediaBannerComponent {
  static Instance: MediaBannerComponent;
}
